import * as React from 'react';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import type { PageNavLink as PageNavLinkType } from 'bundles/unified-common/hooks/useEnterprisePageHeaderLinks';

type Props = {
  subNavLinks?: PageNavLinkType[];
};

const EnterpriseSubNavMenuItem = ({ subNavLinks }: Props) => {
  if (!subNavLinks) {
    return null;
  }
  const filteredNavLinks = subNavLinks.filter((link) => link.label !== 'Home' && link.label !== 'My Learning');

  return (
    <React.Fragment>
      {filteredNavLinks.map((link) => (
        <MobileButton key={link.label} name={link.label} href={link.href} label={link.label} />
      ))}
    </React.Fragment>
  );
};

export default EnterpriseSubNavMenuItem;
